import Network from 'infrastructure/js/modules/network';
import { api as messageDialogApi }  from '../../../MessageDialog/messageDialogActions.js';
import * as partTypesService from '../../../../services/PartTypes/partTypesService.js';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? partTypesService.editPartType : partTypesService.createPartType,
  },

  apiOverrides: {
    fetchDialogData(dispatch, getState) {
      return function () {
        return partTypesService.fetchPartTypes().then((response) => {
          if (!Network.isResponseValid(response)) {
            console.error('Fetch part types failed', response);
            messageDialogApi.responseError(dispatch, getState)(response);
            return {success: false};
          }

          const uniqueFilteredResponse = _.uniqBy(response.dataList, 'description').filter(item => item.description);
          let dialogData = {
            partNames: uniqueFilteredResponse?.map((obj) => {
              return {value: obj.id, label: obj.description, data: obj}
            }) || [],
          };

          dispatch(actions.fetchDialogDataReady(dialogData));
          return {success: true};
        });
      }
    },
  },

});

// const config = {
//   getSubmitMethod: (submitConfigData) => {
//     return submitConfigData && submitConfigData.isEditMode ?
//       partTypesService.editPartType : partTypesService.createPartType;
//   }
// };
//
// export const actionTypes = {
//   ...commonActions.actionTypes,
// };
//
// const actions = {
//   ...commonActions.getActions(),
// };
//
// export let api = {
//   ...commonActions.getApiActions(actions, config),
//
//   fetchDialogData(dispatch, getState) {
//     return function() {
//       return partTypesService.fetchPartTypes().then((response) => {
//         if (!Network.isResponseValid(response)) {
//           console.error('Fetch part types failed', response);
//           messageDialogApi.responseError(dispatch, getState)(response);
//           return {success: false};
//         }
//
//         const uniqueFilteredResponse = _.uniqBy(response.dataList, 'description').filter(item => item.description);
//         let dialogData = {
//           partNames: uniqueFilteredResponse?.map((obj) => {return {value: obj.id, label: obj.description, data: obj}}) || [],
//         };
//
//         dispatch(actions.fetchDialogDataReady(dialogData));
//         return {success: true};
//       });
//     }
//   }
// }
//
// export let jsxActions = {
//   ...commonActions.getJsxActions(api),
// };
